import {useLocation} from "@reach/router";

export const isActiveMenuItem = (href: string): boolean => {

    const {pathname} = useLocation();

    const hrefNodes = href.split('/');
    const routerNodes = pathname.split('/').slice(0, hrefNodes.length);

    return (hrefNodes.toString() === routerNodes.toString());
}
